import { createGlobalStyle } from "styled-components";

export const AppRoot = createGlobalStyle`
  body {
    font-family: "Plus Jakarta Sans", sans-serif;
    overflow-wrap: break-word
  }
`;
